module.exports = __webpack_public_path__ + "606fd335c14e2054e6ad55b1fb147462.png";